import React from 'react'
import { TextField } from '@material-ui/core'
import { Controller } from 'react-hook-form'

const FormInputText = params => {
  return (
    <Controller
      name={params.name}
      control={params.control}
      {...params}
      render={({ field: { onChange, value }, fieldState: { error }, formState }) => (
        <>
          <TextField
            {...params}
            helperText={
              error
                ? error.message
                  ? error.message
                  : error.type === 'required'
                  ? 'Ce champ est obligatoire'
                  : null
                : null
            }
            error={!!error}
            onChange={onChange}
            value={value}
            fullWidth
          />
        </>
      )}
    />
  )
}

export default FormInputText
